// As frases em portugues do "esqueci minha senha", separadas do AuthProvider
// para poderem ser testadas: componente com hook nao roda no vitest daqui.

export interface ErroAuth {
  code?: string
  message: string
}

export function mensagemDoPedido(erro: ErroAuth | null): string | null {
  if (!erro) return null
  if (erro.code === 'over_email_send_rate_limit') {
    return 'Já pedimos e-mails demais na última hora. Espere alguns minutos e tente de novo — ou fale com quem te entregou o login.'
  }
  return 'Não foi possível enviar o link. Verifique sua conexão e tente novamente.'
}

export const MINIMO_DA_SENHA = 8

export function validarNovaSenha(senha: string, repeticao: string): string | null {
  if (senha.length < MINIMO_DA_SENHA) {
    return `A senha precisa ter pelo menos ${MINIMO_DA_SENHA} caracteres.`
  }
  if (senha !== repeticao) return 'As duas senhas não são iguais.'
  return null
}

// A MESMA frase serve duas situacoes que a pessoa nao distingue: o link ja
// tinha vencido quando ela abriu (a tela /nova-senha nao acha sessao), e o
// link venceu entre abrir e salvar (o servidor recusa). Uma dona so, para as
// duas nao divergirem com o tempo.
export const LINK_VENCIDO = 'Este link já venceu ou já foi usado. Peça um novo na tela de login.'

export function mensagemDaTroca(erro: ErroAuth | null): string | null {
  if (!erro) return null
  if (erro.code === 'session_not_found') return LINK_VENCIDO
  if (erro.code === 'same_password') return 'A senha nova precisa ser diferente da anterior.'
  if (erro.code === 'weak_password') {
    return 'Essa senha é fraca demais. Tente uma com letras e números.'
  }
  return 'Não foi possível salvar a senha nova. Verifique sua conexão e tente novamente.'
}
